export default __webpack_public_path__ + "static/media/zodiac05.28dd7271.png";